// src/components/AddressSearch-Selector.jsx

// --- To switch between search providers, comment out one line and uncomment the other. ---

// Option 1: OpenStreetMap (Nominatim) (blue background)
//import AddressSearchInput from './AddressSearch-OpenStreetMap';

// Option 2: Google Maps (yellow background)
import AddressSearchInput from './AddressSearch-Google';

export default AddressSearchInput;
